import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Toolbar, AppBar, Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AppState from '../../../models/redux/state/app.state';
import { logoutAPIcall } from '../../../redux/actions/auth/auth.actions';
import history from '../../../services/browserHistory';
import { purple, yellow, white } from '../../../app/theme';

const useStyles = makeStyles(() => ({
  root: {
    boxShadow: 'none',
    backgroundColor: purple,
    height: 70,
  },
  topToolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    height: 70,
    color: white,
  },
  leftSide: {
    display: 'flex',
  },
  healthcare: {
    fontSize: 16,
    letterSpacing: 0,
    paddingTop: 8,
    paddingLeft: 41,
    opacity: '90%',
    color: white,
  },
  separator: {
    color: yellow,
    paddingTop: 8,
    paddingLeft: 16,
    paddingRight: 4,
  },
  whiteLinks: {
    fontSize: 16,
    fontWeight: 600,
  },
  rightSide: {
    display: 'flex',
    paddingRight: 37,
  },
  rightSideButtons: {
    textTransform: 'none',
    fontSize: 16,
    fontWeight: 600,
  },
  buttonSeparator: {
    color: yellow,
    paddingTop: 8,
    paddingLeft: 4,
    paddingRight: 4,
  },
}));

const AxuminTrainingNavBar = (): JSX.Element => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const auth = useSelector((state: AppState) => state.auth);

  const handleClickMyProfile = () => {
    history.push('/profile');
  };
  const handleClickLogout = () => {
    dispatch(logoutAPIcall());
  };

  return (
    <AppBar className={classes.root} position="static">
      <Toolbar className={classes.topToolbar}>
        {/* Left side */}
        <div className={classes.leftSide}>
          <Typography className={classes.healthcare}>
            <em>FOR US HEALTHCARE PROFESSIONALS</em>
          </Typography>
          <Typography className={classes.separator}>|</Typography>
          <Button className={classes.whiteLinks} onClick={() => history.push('/trainings')} color="inherit">
            BLUE EARTH DX TRAINING
          </Button>
          <Typography className={classes.buttonSeparator}>|</Typography>
          <Button
            className={classes.whiteLinks}
            color="inherit"
            href="https://www.axumin.com/prescribing-information.pdf"
            target="_blank"
            rel="noreferrer"
          >
            PRESCRIBING INFORMATION
          </Button>
        </div>

        {/* Right side */}
        <div className={classes.rightSide}>
          {auth.user?.isAdmin && (
            <>
              <Button
                className={classes.rightSideButtons}
                onClick={() => history.push('/admin', { from: history.location.pathname })}
                color="inherit"
              >
                Admin Portal
              </Button>
              <Typography className={classes.buttonSeparator}>|</Typography>
            </>
          )}
          <Button className={classes.rightSideButtons} onClick={handleClickMyProfile} color="inherit">
            My Profile
          </Button>
          <Typography className={classes.buttonSeparator}>|</Typography>
          <Button className={classes.rightSideButtons} onClick={handleClickLogout} color="inherit">
            Log Out
          </Button>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default AxuminTrainingNavBar;
